import React, {lazy, Suspense} from 'react';
import {Provider} from 'react-redux'

import {withStyles} from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline'
// ------------------------------------------------------------------------------------------------------------------ //
// initialize i18n
// ------------------------------------------------------------------------------------------------------------------ //
import i18n from "./../../../libs/i18n";
import ja from './locale/ja';
import en from './locale/en';
// ------------------------------------------------------------------------------------------------------------------ //
// additional imports
// ------------------------------------------------------------------------------------------------------------------ //
import {BrowserRouter} from 'react-router-dom'
import Toolkit from "../../../libs/Toolkit";
import * as Store from "./FrontendLandingPageReducer";

const LandingPageAppBar = lazy(() => import('./LandingPageAppBar'));
const ItemThumbnailGrid = lazy(() => import('./ItemThumbnailGrid'));

i18n.addResourceBundle("en", "translation", en.translation);
i18n.addResourceBundle("ja", "translation", ja.translation);


// ------------------------------------------------------------------------------------------------------------------ //
// Style
// ------------------------------------------------------------------------------------------------------------------ //
const style = {
    root: {},
};

// ------------------------------------------------------------------------------------------------------------------ //
// component
// ------------------------------------------------------------------------------------------------------------------ //
class FrontendLandingPageApp extends React.Component
{
    constructor(props)
    {
        super(props);

        let params = Toolkit.urlQuery();

        this.state = {
            item_id: atob(params['item']),
            item: null,

            show_config_error: false,
        };
    }

    componentDidMount()
    {
        Toolkit.request(this,
            '/api/get_items',
            {
                item_id: this.state.item_id
            },
            (res) =>
            {
                this.setState({item: res.items[0]});
            }
        );
    }

    render()
    {
        if (!this.state.item_id)
            return (
                <React.Fragment>item not found.</React.Fragment>
            );

        return (
            <Provider store={Store.FrontendLandingPageReducer}>
                <BrowserRouter>
                    <div className={this.props.classes.root}>
                        <Suspense fallback={<div>Loading...</div>}>
                            <CssBaseline/>
                            <LandingPageAppBar item={this.state.item}/>

                            <ItemThumbnailGrid item={this.state.item}/>
                        </Suspense>
                    </div>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default withStyles(style)(FrontendLandingPageApp);
